import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { getLocalizedUrl } from '../utils/languageHelper';

export const SERVICES = [
  // Text Tools
  { id: 'nav.textReplacer', defaultTitle: 'Text Replacer', path: '/replace-text', category: 'Text Tools', tags: ['replace', 'find', 'regex', 'substitute', 'substituir', 'texto'] },
  { id: 'nav.duplicateRemover', defaultTitle: 'Duplicate Line Remover', path: '/remove-duplicate-lines', category: 'Text Tools', tags: ['duplicate', 'lines', 'unique', 'clean', 'duplicadas', 'linhas'] },
  { id: 'nav.markdownToHtml', defaultTitle: 'Markdown to HTML', path: '/markdown-to-html', category: 'Text Tools', tags: ['markdown', 'html', 'converter', 'md', 'preview'] },
  { id: 'nav.htmlToMarkdown', defaultTitle: 'HTML to Markdown', path: '/html-to-markdown', category: 'Text Tools', tags: ['html', 'markdown', 'converter', 'md', 'code'] },
  { id: 'nav.loremIpsum', defaultTitle: 'Lorem Ipsum Generator', path: '/lorem-ipsum', category: 'Text Tools', tags: ['lorem', 'ipsum', 'dummy', 'text', 'placeholder', 'texto'] },
  { id: 'nav.characterCount', defaultTitle: 'Character Count', path: '/character-count', category: 'Text Tools', tags: ['character', 'count', 'word', 'length', 'caracteres', 'palavras'] },
  { id: 'nav.tallyCounter', defaultTitle: 'Tally Counter', path: '/tally-counter', category: 'Text Tools', tags: ['tally', 'counter', 'clicker', 'cliques', 'contador'] },

  // Code & Data
  { id: 'nav.jsonPretty', defaultTitle: 'JSON Pretty Print', path: '/json-pretty-print', category: 'Code & Data', tags: ['json', 'pretty', 'format', 'beautify', 'formatar'] },
  { id: 'nav.xmlPretty', defaultTitle: 'XML Pretty Print', path: '/xml-pretty-print', category: 'Code & Data', tags: ['xml', 'pretty', 'format', 'beautify'] },
  { id: 'nav.htmlFormatter', defaultTitle: 'HTML Formatter', path: '/html-formatter', category: 'Code & Data', tags: ['html', 'format', 'beautifier'] },
  { id: 'nav.cssBeautifier', defaultTitle: 'CSS Beautifier', path: '/css-beautifier', category: 'Code & Data', tags: ['css', 'format', 'beautifier', 'estilos'] },
  { id: 'nav.codeMinifier', defaultTitle: 'Code Minifier (CSS/JS)', path: '/code-minifier', category: 'Code & Data', tags: ['minify', 'minifier', 'css', 'js', 'javascript', 'compress', 'minificar'] },
  { id: 'nav.jsonToCsv', defaultTitle: 'JSON to CSV / Excel', path: '/json-to-csv', category: 'Code & Data', tags: ['json', 'csv', 'excel', 'spreadsheet', 'table', 'tabela', 'planilha'] },
  { id: 'nav.csvToJson', defaultTitle: 'CSV to JSON', path: '/csv-to-json', category: 'Code & Data', tags: ['csv', 'json', 'excel', 'parse', 'converter', 'tabela'] },
  { id: 'nav.base64Converter', defaultTitle: 'Base64 Converter', path: '/base64-converter', category: 'Code & Data', tags: ['base64', 'encode', 'decode', 'binary', 'converter'] },
  { id: 'nav.imageToWebp', defaultTitle: 'Image to WebP (PNG/JPG)', path: '/image-to-webp', category: 'Code & Data', tags: ['image', 'webp', 'png', 'jpg', 'jpeg', 'photo', 'compress', 'foto', 'converter', 'imagem'] },

  // Security
  { id: 'nav.passwordGenerator', defaultTitle: 'Password Generator', path: '/password-generator', category: 'Security', tags: ['password', 'generator', 'senha', 'gerador', 'secure'] },
  { id: 'nav.passwordStrength', defaultTitle: 'Password Strength Checker', path: '/password-strength-checker', category: 'Security', tags: ['password', 'strength', 'checker', 'senha', 'segurança', 'entropy'] },
  { id: 'nav.hashGenerator', defaultTitle: 'Cryptographic Hash Generator', path: '/hash-generator', category: 'Security', tags: ['hash', 'md5', 'sha1', 'sha256', 'sha512', 'crypto'] },

  // Calculators
  { id: 'nav.simpleCalculator', defaultTitle: 'Simple Calculator', path: '/calculator', category: 'Calculators', tags: ['calculator', 'math', 'calculadora', 'calc'] },
  { id: 'nav.timeCalculator', defaultTitle: 'Time Calculator', path: '/time-calculator', category: 'Calculators', tags: ['time', 'hours', 'minutes', 'horas', 'tempo', 'calculadora'] },
  { id: 'nav.qrCode', defaultTitle: 'QR Code Generator', path: '/qr-code-generator', category: 'Utilities', tags: ['qr', 'qrcode', 'generator', 'code', 'codigo'] },

  // Translators
  { id: 'nav.morseCode', defaultTitle: 'Morse Code Translator', path: '/morse-code', category: 'Translators', tags: ['morse', 'code', 'translator', 'audio', 'som'] },
  { id: 'nav.binaryCode', defaultTitle: 'Binary Code Translator', path: '/binary-code-translator', category: 'Translators', tags: ['binary', 'code', 'binario', 'translator', '01'] },
  { id: 'nav.wingdings', defaultTitle: 'Wingding Translator', path: '/wingdings-translator', category: 'Translators', tags: ['wingdings', 'dingbat', 'translator', 'symbols', 'simbolos'] },

  // UUID Tools
  { id: 'nav.uuidGenerator', defaultTitle: 'UUID Generator', path: '/uuid-generator', category: 'UUID Tools', tags: ['uuid', 'guid', 'v4', 'generator', 'gerador'] },
  { id: 'nav.uuidFormatter', defaultTitle: 'UUID Formatter', path: '/uuid-formatter', category: 'UUID Tools', tags: ['uuid', 'guid', 'format', 'uppercase', 'hyphens'] },
  { id: 'nav.uuidValidator', defaultTitle: 'UUID Validator', path: '/uuid-validator', category: 'UUID Tools', tags: ['uuid', 'guid', 'validate', 'validator', 'validador'] },

  // Random
  { id: 'nav.wheelDecide', defaultTitle: 'Wheel Decide', path: '/wheel-decide', category: 'Random', tags: ['wheel', 'decide', 'picker', 'roleta', 'sorteio', 'names'] },
  { id: 'nav.randomName', defaultTitle: 'Random Name Generator', path: '/random-name', category: 'Random', tags: ['random', 'name', 'names', 'nomes', 'gerador'] },
  { id: 'nav.randomNumber', defaultTitle: 'Random Number Generator', path: '/random-number', category: 'Random', tags: ['random', 'number', 'numbers', 'numeros', 'sorteio'] },

  // New High-Traffic & High-RPM Tools
  { id: 'nav.diffChecker', defaultTitle: 'Diff Checker (Text Compare)', path: '/diff-checker', category: 'Text Tools', tags: ['diff', 'compare', 'difference', 'comparar', 'diferenca', 'texto', 'code'] },
  { id: 'nav.jwtDecoder', defaultTitle: 'JWT Decoder & Inspector', path: '/jwt-decoder', category: 'Code & Data', tags: ['jwt', 'json', 'token', 'decode', 'bearer', 'auth', 'decodificar'] },
  { id: 'nav.cronGenerator', defaultTitle: 'Cron Expression Generator', path: '/cron-expression-generator', category: 'Code & Data', tags: ['cron', 'crontab', 'schedule', 'agendamento', 'linux'] },
  { id: 'nav.sqlFormatter', defaultTitle: 'SQL Formatter & Beautifier', path: '/sql-formatter', category: 'Code & Data', tags: ['sql', 'format', 'beautify', 'query', 'postgres', 'mysql', 'database'] },
  { id: 'nav.regexTester', defaultTitle: 'Regex Tester & Simulator', path: '/regex-tester', category: 'Code & Data', tags: ['regex', 'regexp', 'regular', 'expression', 'test', 'match', 'padrao'] },
  { id: 'nav.exifRemover', defaultTitle: 'EXIF Metadata Remover', path: '/exif-remover', category: 'Code & Data', tags: ['exif', 'metadata', 'gps', 'photo', 'privacy', 'camera', 'remover', 'imagem'] },
  { id: 'nav.compoundInterest', defaultTitle: 'Compound Interest Calculator', path: '/compound-interest-calculator', category: 'Calculators', tags: ['compound', 'interest', 'investment', 'juros', 'compostos', 'investimento', 'calculadora'] },
  { id: 'nav.profitMargin', defaultTitle: 'Profit Margin & Markup', path: '/profit-margin-calculator', category: 'Calculators', tags: ['profit', 'margin', 'markup', 'lucro', 'margem', 'preco', 'precificacao'] },
  { id: 'nav.freelanceRate', defaultTitle: 'Freelance Rate Calculator', path: '/freelance-rate-calculator', category: 'Calculators', tags: ['freelance', 'rate', 'hourly', 'salary', 'valor', 'hora', 'salario'] },
  { id: 'nav.cpmCalculator', defaultTitle: 'Paid Media & CPM Calculator', path: '/cpm-calculator', category: 'Calculators', tags: ['cpm', 'cpc', 'ctr', 'roas', 'cac', 'ads', 'marketing', 'midia'] },
  { id: 'nav.utmBuilder', defaultTitle: 'UTM Campaign Builder', path: '/utm-builder', category: 'Marketing', tags: ['utm', 'campaign', 'url', 'builder', 'analytics', 'tracking', 'campanha'] },
  { id: 'nav.openGraphPreview', defaultTitle: 'Open Graph & Social Preview', path: '/open-graph-preview', category: 'Marketing', tags: ['open', 'graph', 'og', 'preview', 'social', 'meta', 'tags', 'twitter', 'facebook'] },
  { id: 'nav.debtPayoff', defaultTitle: 'US Debt Payoff Calculator', path: '/debt-payoff-calculator', category: 'Calculators', tags: ['debt', 'payoff', 'snowball', 'avalanche', 'credit', 'card', 'loan', 'dividas', 'quitacao', 'calculadora', 'juros', 'dave', 'ramsey'] },
   { id: 'nav.mortgageCalc', defaultTitle: 'Mortgage Calculator & Schedule', path: '/mortgage-calculator', category: 'Calculators', tags: ['mortgage', 'amortization', 'schedule', 'home', 'loan', 'piti', 'rocket', 'interest', 'financiamento', 'imobiliario', 'tabela', 'price', 'parcela', 'casa', 'hipoteca'] },
  { id: 'nav.insuranceCalc', defaultTitle: 'Car & Life Insurance Calculator', path: '/car-insurance-calculator', category: 'Calculators', tags: ['car', 'auto', 'insurance', 'life', 'term', 'quote', 'premium', 'dime', 'seguro', 'carro', 'automovel', 'vida', 'veiculo', 'texas', 'florida', 'california', 'policy', 'underwriting'] },
  { id: 'nav.unitConverter', defaultTitle: 'Unit Converter (Inches to CM, Lbs to KG)', path: '/unit-converter', category: 'Calculators', tags: ['unit', 'converter', 'inches', 'cm', 'lbs', 'kg', 'miles', 'km', 'feet', 'meters', 'height', 'polegadas', 'libras', 'quilos', 'centimetros', 'medidas', 'conversor', 'altura'] },
  { id: 'nav.tempConverter', defaultTitle: 'Temperature Converter (°F to °C)', path: '/temperature-converter', category: 'Calculators', tags: ['temperature', 'converter', 'fahrenheit', 'celsius', 'kelvin', 'temp', 'oven', 'baking', 'forno', 'temperatura', 'graus', 'termometro', '350f', 'febril'] }
];

const CATEGORY_MAP = {
  'Text Tools': 'nav.textTools',
  'Code & Data': 'nav.codeData',
  'Security': 'nav.security',
  'Calculators': 'nav.calculators',
  'Utilities': 'nav.utilities',
  'Translators': 'nav.translators',
  'UUID Tools': 'nav.uuidTools',
  'Random': 'nav.random',
  'Marketing': 'nav.marketing'
};

export const ServiceSearch = ({ intl, currentLang, history }) => {
  const [query, setQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const containerRef = useRef(null);
  const inputRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    if (typeof window !== 'undefined') {
      document.addEventListener('mousedown', handleOutsideClick);
      document.addEventListener('touchstart', handleOutsideClick);
    }
    return () => {
      if (typeof window !== 'undefined') {
        document.removeEventListener('mousedown', handleOutsideClick);
        document.removeEventListener('touchstart', handleOutsideClick);
      }
    };
  }, []);

  // Filter services based on query
  const trimmedQuery = query.trim().toLowerCase();

  const results = trimmedQuery ? SERVICES.filter(service => {
    const localizedTitle = intl.formatMessage({ id: service.id, defaultMessage: service.defaultTitle }).toLowerCase();
    const localizedCategory = intl.formatMessage({
      id: CATEGORY_MAP[service.category] || 'nav.utilities',
      defaultMessage: service.category
    }).toLowerCase();
    const matchesTitle = localizedTitle.includes(trimmedQuery) || service.defaultTitle.toLowerCase().includes(trimmedQuery);
    const matchesPath = service.path.toLowerCase().includes(trimmedQuery);
    const matchesCategory = service.category.toLowerCase().includes(trimmedQuery) || localizedCategory.includes(trimmedQuery);
    const matchesTag = service.tags.some(tag => tag.toLowerCase().includes(trimmedQuery));
    return matchesTitle || matchesPath || matchesCategory || matchesTag;
  }).sort((a, b) => {
    // Prioritize results whose title starts with or contains query
    const aTitle = intl.formatMessage({ id: a.id, defaultMessage: a.defaultTitle }).toLowerCase();
    const bTitle = intl.formatMessage({ id: b.id, defaultMessage: b.defaultTitle }).toLowerCase();
    const aStarts = aTitle.startsWith(trimmedQuery);
    const bStarts = bTitle.startsWith(trimmedQuery);
    if (aStarts && !bStarts) return -1;
    if (!aStarts && bStarts) return 1;
    return aTitle.localeCompare(bTitle);
  }) : [];

  const handleSelectService = (service) => {
    const targetUrl = getLocalizedUrl(service.path, currentLang);
    setIsOpen(false);
    setQuery('');
    setSelectedIndex(-1);
    if (history && history.push) {
      history.push(targetUrl);
    } else if (typeof window !== 'undefined') {
      window.location.href = targetUrl;
    }
  };

  const handleKeyDown = (e) => {
    if (!isOpen || results.length === 0) {
      if (e.key === 'ArrowDown' && results.length > 0) {
        setIsOpen(true);
      }
      return;
    }

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setSelectedIndex(prev => (prev < results.length - 1 ? prev + 1 : 0));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setSelectedIndex(prev => (prev > 0 ? prev - 1 : results.length - 1));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (selectedIndex >= 0 && selectedIndex < results.length) {
        handleSelectService(results[selectedIndex]);
      } else if (results.length > 0) {
        handleSelectService(results[0]);
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      setIsOpen(false);
      setSelectedIndex(-1);
      if (inputRef.current) {
        inputRef.current.blur();
      }
    }
  };

  const highlightMatch = (text, term) => {
    if (!term) return text;
    const index = text.toLowerCase().indexOf(term);
    if (index === -1) return text;

    const before = text.substring(0, index);
    const match = text.substring(index, index + term.length);
    const after = text.substring(index + term.length);

    return (
      <React.Fragment>
        {before}
        <strong className="text-primary font-weight-bold" style={{ textDecoration: 'underline' }}>{match}</strong>
        {after}
      </React.Fragment>
    );
  };

  const placeholderText = intl.formatMessage({
    id: 'header.search.placeholder',
    defaultMessage: 'Search tools (e.g. CSV, JSON, WebP)...'
  });

  return (
    <div
      ref={containerRef}
      className="position-relative service-search-container my-1 my-lg-0"
      style={{ minWidth: '200px', maxWidth: '280px' }}
    >
      <div className="input-group input-group-sm" style={{ height: '31px' }}>
        <div className="input-group-prepend">
          <span
            className="input-group-text bg-secondary border-secondary text-light px-2"
            id="search-addon"
            style={{ height: '31px', lineHeight: '31px' }}
          >
            <span role="img" aria-label="search">🔍</span>
          </span>
        </div>
        <input
          ref={inputRef}
          type="search"
          className="form-control form-control-sm bg-dark text-light border-secondary shadow-none"
          placeholder={placeholderText}
          aria-label="Search tools"
          aria-describedby="search-addon"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setIsOpen(true);
            setSelectedIndex(-1);
          }}
          onFocus={() => {
            if (query.trim()) {
              setIsOpen(true);
            }
          }}
          onKeyDown={handleKeyDown}
          autoComplete="off"
          id="headerServiceSearchInput"
          style={{ fontSize: '13px', height: '31px' }}
        />
        {query && (
          <div className="input-group-append">
            <button
              className="btn btn-sm btn-secondary border-secondary text-light px-2 d-flex align-items-center justify-content-center"
              type="button"
              onClick={() => {
                setQuery('');
                setIsOpen(false);
                setSelectedIndex(-1);
                if (inputRef.current) inputRef.current.focus();
              }}
              title="Clear"
              aria-label="Clear search"
              style={{ height: '31px', lineHeight: '1' }}
            >
              &times;
            </button>
          </div>
        )}
      </div>

      {/* Floating Autocomplete Results Dropdown */}
      {isOpen && trimmedQuery && (
        <div
          className="dropdown-menu show position-absolute w-100 mt-1 shadow-lg border-secondary"
          style={{
            maxHeight: '380px',
            overflowY: 'auto',
            zIndex: 1060,
            backgroundColor: '#ffffff',
            borderRadius: '6px'
          }}
          role="listbox"
          id="searchAutocompleteDropdown"
        >
          {results.length > 0 ? (
            results.map((service, index) => {
              const localizedTitle = intl.formatMessage({ id: service.id, defaultMessage: service.defaultTitle });
              const isSelected = index === selectedIndex;
              return (
                <a
                  key={service.path}
                  href={getLocalizedUrl(service.path, currentLang)}
                  className={`dropdown-item py-2 px-3 d-flex justify-content-between align-items-center ${
                    isSelected ? 'active bg-primary text-white' : 'text-dark'
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSelectService(service);
                  }}
                  onMouseEnter={() => setSelectedIndex(index)}
                  role="option"
                  aria-selected={isSelected}
                  style={{ cursor: 'pointer', whiteSpace: 'normal' }}
                >
                  <div>
                    <div className="font-weight-bold" style={{ fontSize: '13px' }}>
                      {highlightMatch(localizedTitle, trimmedQuery)}
                    </div>
                    <small className={isSelected ? 'text-white-50' : 'text-muted'}>
                      {service.path}
                    </small>
                  </div>
                  <span
                    className={`badge badge-pill ml-2 flex-shrink-0 ${
                      isSelected ? 'badge-light text-primary' : 'badge-secondary text-white'
                    }`}
                    style={{ fontSize: '10px' }}
                  >
                    {intl.formatMessage({
                      id: CATEGORY_MAP[service.category] || 'nav.utilities',
                      defaultMessage: service.category
                    })}
                  </span>
                </a>
              );
            })
          ) : (
            <div className="dropdown-item disabled text-muted text-center py-3 small">
              {intl.formatMessage({ id: 'header.search.noResults', defaultMessage: 'No tools found for' })} &quot;{query}&quot;
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default withRouter(injectIntl(ServiceSearch));
